import React, { Component } from 'react';
import './Resultat.js.css';

export class Resultat extends Component {
    render() {
        return (
            <section className='resultat'>
                <h4>
                    Résultats des enquêtes des titulaires de permis (CPE et garderies)
                </h4>
                <p>
                    La Direction des enquêtes du ministère de la Famille (Ministère) planifie, organise et supervise l’ensemble
                    des enquêtes menées sur tout le territoire du Québec auprès des services de garde éducatifs à l’enfance.
                    Les enquêtes effectuées ont pour but de veiller à l’application du cadre normatif, qui a notamment pour objet
                    de promouvoir la qualité des services de garde éducatifs à l’enfance en vue d’assurer la santé, la sécurité,
                    le développement, la réussite éducative, le bien-être et l’égalité des chances des enfants qui reçoivent ces
                    services.
                </p>
                <p>
                    Une enquête peut notamment être initiée à la suite d’une plainte, d’une divulgation d’un acte répréhensible,
                    d’une inspection ou lorsque le Ministère est informé d’un signalement au DPJ.
                </p>
                <p>
                    Certaines enquêtes menées par le Ministère peuvent être de nature pénale. Le cas échéant, le prestataire de
                    service de garde qui contrevient à la Loi sur les services de garde éducatifs à l’enfance (LSGEE) ou à ses
                    règlements peut faire l’objet de poursuites pénales, à la suite de l’émission de constats d’infraction par
                    le Directeur des poursuites criminelles et pénales.
                </p>
                <p>
                    La LSGEE prévoit également que la personne qui dirige ou représente le titulaire de permis peut également
                    faire l’objet de poursuites pénales s’il est démontré qu’elle a autorisé ou permis la perpétration d’une
                    infraction ou encore qu’elle y a consenti.
                </p>
                <p>
                    Toutes questions quant aux circonstances d’une infraction ou aux mesures que le service de garde a mises en
                    place pour éviter que l’infraction se reproduise peuvent être abordées avec un représentant du service de garde.
                </p>
                <p>
                    Les enquêtes entreprises par le Ministère permettent de s’assurer que les titulaires de permis respectent les
                    dispositions législatives et réglementaires auxquelles ils sont assujettis. Ces dispositions ont pour objectif
                    de s’assurer de la santé, la sécurité et le bien-être des enfants qui fréquentent ces services de garde.
                </p>
            </section >
        );
    }
}
